// extracted by mini-css-extract-plugin
export default {"price":"y7-z","onSale":"z7-z","msrpLabelPrice":"A7-z","msrpLabel":"B7-z","originalPrice":"C7-z","percentOff":"D7-z"};